import { useContext, useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { ChatResponseType } from '@trinity/chat';
import { useChatApiClient } from '@trinity/chat-components/containers/Chat/useApiClient.js';
import { ActiveChatSessionContext, ChatHintsLoadingContext, ChatInitialResponseContext } from './context';

type Props = {
  children: React.ReactNode;
};

export const ChatHintsContainer = (props: Props) => {
  const chat = useContext(ActiveChatSessionContext);
  const client = useChatApiClient();

  const query = useQuery({
    queryKey: ['chat-hints', chat.identifier, chat.context],
    queryFn: () => {
      return client.chat.getChatInitialMessage({
        context: chat.context,
      });
    },
    refetchOnMount: 'always',
    initialData: {
      type: ChatResponseType.InitialGreeting,
      value: '',
      data: {
        hints: [],
      },
    },
  });

  const loading = useMemo(() => {
    return query.isFetching;
  }, [query.isFetching]);

  return (
    <ChatInitialResponseContext.Provider value={query.data}>
      <ChatHintsLoadingContext.Provider value={loading}>{props.children}</ChatHintsLoadingContext.Provider>
    </ChatInitialResponseContext.Provider>
  );
};
